import { basicFields, contactFields } from "../../configs/customer";
import { validate } from "../../utils/validation";

export function validateCustomer(customer: any): Record<string, string> {
    const errors: Record<string, string> = {};
    const check = (data: any, fields: typeof basicFields, prefix = "") => {
        fields.forEach(field => {
            const value = String(data?.[field.key] ?? "");
            if (field.required && !value.trim()) {
                errors[prefix + field.key] = "Đây là trường bắt buộc";
            } else if (field.validation) {
                const message = validate(value, field.validation);
                if (message) errors[prefix + field.key] = message;
            }
        });
    };
    check(customer, basicFields);
    (customer.contact_list || []).forEach((entry: any, index: number) =>
        check(entry.contact, contactFields, `contact_list.${index}.contact.`));
    return errors;
}

export function normalizeCustomerPayload(customer: any) {
    return {
        ...customer,
        name: customer.name?.trim(),
        customer_code: customer.customer_code?.trim() || null,
        tax_id: customer.tax_id?.trim() || "",
        phone: String(customer.phone ?? "").replace(/^ +| +$/g, ""),
        email: customer.email?.trim() || "",
        payable_days: customer.payable_days === "" || customer.payable_days == null ? 0 : Number(customer.payable_days),
        credit_limit: customer.credit_limit === "" || customer.credit_limit == null ? 0 : Number(customer.credit_limit),
        contact_list: (customer.contact_list || []).filter(({ contact }: any) =>
            ["name", "phone", "email", "position"].some(key => String(contact?.[key] ?? "").trim())),
    };
}

export function customerApiErrors(error: any): Record<string, string> {
    const data = error?.response?.data || error?.data || error;
    const result: Record<string, string> = {};
    const labels = Object.fromEntries([...basicFields, ...contactFields].map(field => [field.label, field.key]));
    labels["Danh sách liên hệ"] = "contact_list";
    const visit = (value: any, path: string) => {
        if (Array.isArray(value) && value.every(item => typeof item === "string")) {
            result[path] = value.join(" ");
        } else if (value && typeof value === "object") {
            Object.entries(value).forEach(([key, child]) => visit(child, [path, labels[key] || key].filter(Boolean).join(".")));
        } else if (typeof value === "string" && path) {
            result[path] = value;
        }
    };
    visit(data, "");
    return result;
}
